import { css as m, LitElement as g, html as p, nothing as d } from "lit";
import { property as l, customElement as h } from "lit/decorators.js";
import { classMap as f } from "lit/directives/class-map.js";
import { b } from "./styles-scZ6dVz-.js";
import { b as u, a as v } from "./events-CkEPl0SM.js";
var y = Object.defineProperty, k = Object.getOwnPropertyDescriptor, o = (a, i, e, n) => {
  for (var t = n > 1 ? void 0 : n ? k(i, e) : i, s = a.length - 1, c; s >= 0; s--)
    (c = a[s]) && (t = (n ? c(i, e, t) : c(t)) || t);
  return n && t && y(i, e, t), t;
};
let r = class extends g {
  constructor() {
    super(...arguments), this.variant = "secondary", this.size = "md", this.removable = !1, this.clickable = !1, this.outline = !1, this.rounded = !1;
  }
  handleRemove(a) {
    a.stopPropagation(), u(this, v.REMOVE);
  }
  handleClick() {
    this.clickable && u(this, v.CLICK);
  }
  render() {
    const a = {
      tag: !0,
      [this.variant]: !0,
      [this.size]: !0,
      outline: this.outline,
      rounded: this.rounded,
      clickable: this.clickable
    }, i = p`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
      </svg>
    `;
    return p`
      <span
        part="tag"
        class=${f(a)}
        role=${this.clickable ? "button" : d}
        tabindex=${this.clickable ? "0" : d}
        @click=${this.handleClick}
        @keydown=${(e) => {
      this.clickable && (e.key === "Enter" || e.key === " ") && (e.preventDefault(), this.handleClick());
    }}
      >
        <span part="content" class="content">
          <slot name="prefix"></slot>
          <slot></slot>
        </span>
        ${this.removable ? p`
              <button
                part="remove"
                class="remove"
                type="button"
                aria-label="Remove"
                @click=${this.handleRemove}
              >
                ${i}
              </button>
            ` : d}
      </span>
    `;
  }
};
r.styles = [
  b,
  m`
      :host {
        display: inline-flex;
      }

      .tag {
        display: inline-flex;
        align-items: center;
        gap: var(--r5-space-1);
        font-weight: var(--r5-font-medium);
        border-radius: var(--r5-radius-md);
        white-space: nowrap;
        line-height: 1;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      /* Sizes */
      .sm {
        height: 1.375rem;
        padding: 0 var(--r5-space-2);
        font-size: 0.6875rem;
        gap: var(--r5-space-1);
      }

      .md {
        height: 1.625rem;
        padding: 0 var(--r5-space-2-5);
        font-size: var(--r5-text-xs);
      }

      .lg {
        height: 2rem;
        padding: 0 var(--r5-space-3);
        font-size: var(--r5-text-sm);
      }

      /* Variants */
      .primary {
        background-color: var(--r5-color-primary-100);
        color: var(--r5-color-primary-700);
      }

      .secondary {
        background-color: var(--r5-color-neutral-100);
        color: var(--r5-color-neutral-700);
      }

      .success {
        background-color: var(--r5-color-success-100);
        color: var(--r5-color-success-700);
      }

      .warning {
        background-color: var(--r5-color-warning-100);
        color: var(--r5-color-warning-700);
      }

      .danger {
        background-color: var(--r5-color-danger-100);
        color: var(--r5-color-danger-700);
      }

      .info {
        background-color: var(--r5-color-info-100);
        color: var(--r5-color-info-700);
      }

      /* Outline mode */
      .outline {
        background-color: transparent;
        border: 1px solid currentColor;
      }

      /* Rounded mode */
      .rounded {
        border-radius: var(--r5-radius-full);
      }

      /* Clickable mode */
      .clickable {
        cursor: pointer;
      }

      .clickable:hover {
        filter: brightness(0.95);
      }

      .clickable:active {
        filter: brightness(0.9);
      }

      /* Content */
      .content {
        display: inline-flex;
        align-items: center;
        gap: var(--r5-space-1);
      }

      /* Remove button */
      .remove {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        margin-left: var(--r5-space-1);
        margin-right: calc(-1 * var(--r5-space-1));
        border: none;
        background: transparent;
        color: currentColor;
        opacity: 0.7;
        cursor: pointer;
        border-radius: var(--r5-radius-full);
        transition: opacity var(--r5-duration-fast) var(--r5-ease-default);
      }

      .remove:hover {
        opacity: 1;
      }

      .remove svg {
        width: 0.875em;
        height: 0.875em;
      }

      .sm .remove {
        margin-right: calc(-1 * var(--r5-space-0-5));
      }

      /* Prefix slot */
      ::slotted([slot='prefix']) {
        display: inline-flex;
        align-items: center;
      }
    `
];
o([
  l({ type: String, reflect: !0 })
], r.prototype, "variant", 2);
o([
  l({ type: String, reflect: !0 })
], r.prototype, "size", 2);
o([
  l({ type: Boolean, reflect: !0 })
], r.prototype, "removable", 2);
o([
  l({ type: Boolean, reflect: !0 })
], r.prototype, "clickable", 2);
o([
  l({ type: Boolean, reflect: !0 })
], r.prototype, "outline", 2);
o([
  l({ type: Boolean, reflect: !0 })
], r.prototype, "rounded", 2);
r = o([
  h("ark-tag")
], r);
export {
  r as A
};
//# sourceMappingURL=ark-tag-C1izJi5K.js.map
